var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "divBox relative",
      attrs: {
        "element-loading-text": "正在加载商品数据...",
        "element-loading-spinner": "el-icon-loading",
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-steps",
            {
              staticClass: "mb20",
              attrs: { active: _vm.currentStep, "finish-status": "success" },
            },
            [
              _c("el-step", { attrs: { title: "商品信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "规格库存" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "商品详情" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "其他参数" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("base-info-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentStep === 0,
                expression: "currentStep === 0",
              },
            ],
            ref: "baseInfoForm",
            attrs: {
              form: _vm.goodsForm,
              rules: _vm.goodsRules,
              "cascader-props": _vm.cascaderProps,
              "category-options": _vm.categoryOptions,
              "display-category-options": _vm.displayCategoryOptions,
              "brand-options": _vm.brandOptions,
              "store-options": _vm.filteredStoreOptions,
              "label-options": _vm.labelOptions,
              "wm-tg-flag-options": _vm.wmTgFlagOptions,
              "store-type-options": _vm.productStoreTypeOptions,
              "frt-template-flag": _vm.frtTemplateFlag,
              "frt-template-options": _vm.frtTemplateOptions,
            },
            on: {
              "store-change": _vm.handleStoreChange,
              "store-wmtgflag": _vm.wmTgFlagChange,
              "wm-tg-flag-change": _vm.shippingChange,
            },
          }),
          _vm._v(" "),
          _c("spec-stock-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentStep === 1,
                expression: "currentStep === 1",
              },
            ],
            ref: "specStockForm",
            attrs: {
              isWmTg: _vm.isWmTg,
              "appointment-time-flag": _vm.goodsForm.appointmentTimeFlag,
              singleSpecForm: _vm.singleSpecForm,
              multipleAttr: _vm.multipleAttr,
              attr: _vm.attr,
              attrValue: _vm.attrValue,
              attrType: _vm.attrType,
            },
            model: {
              value: _vm.specStockData,
              callback: function ($$v) {
                _vm.specStockData = $$v
              },
              expression: "specStockData",
            },
          }),
          _vm._v(" "),
          _vm.showDateParameter
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 1,
                      expression: "currentStep === 1",
                    },
                  ],
                  staticClass: "date-parameter-step",
                },
                [
                  _c("DateParameter", {
                    key: _vm.dateParameterMode,
                    ref: "dateParameterRef",
                    attrs: {
                      mode: _vm.dateParameterMode,
                      "store-id": _vm.goodsForm.storeId,
                      "stock-warning": _vm.singleSpecForm.stockWarning,
                    },
                    on: {
                      "update:stockWarning": function ($event) {
                        return _vm.$set(
                          _vm.singleSpecForm,
                          "stockWarning",
                          $event
                        )
                      },
                      "update:stock-warning": function ($event) {
                        return _vm.$set(
                          _vm.singleSpecForm,
                          "stockWarning",
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 2,
                  expression: "currentStep === 2",
                },
              ],
              staticClass: "step-content",
            },
            [
              _c(
                "div",
                { staticClass: "detail-editor-item" },
                [
                  _c("div", { staticClass: "detail-editor-label" }, [
                    _vm._v("商品描述："),
                  ]),
                  _vm._v(" "),
                  _c("Tinymce", {
                    attrs: { height: 500, sourceType: "spu2" },
                    model: {
                      value: _vm.content,
                      callback: function ($$v) {
                        _vm.content = $$v
                      },
                      expression: "content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-editor-item" },
                [
                  _c(
                    "div",
                    { staticClass: "detail-editor-label" },
                    [
                      _vm._v("\n          购买须知：\n          "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "购买须知需展示在移动端“提交订单页”，未填写内容则不展示购买须知",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "el-icon-question detail-editor-tooltip",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Tinymce", {
                    attrs: { height: 500, sourceType: "spu2" },
                    model: {
                      value: _vm.purchaseNotice,
                      callback: function ($$v) {
                        _vm.purchaseNotice = $$v
                      },
                      expression: "purchaseNotice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-editor-item" },
                [
                  _c(
                    "div",
                    { staticClass: "detail-editor-label" },
                    [
                      _vm._v("\n          使用须知：\n          "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "使用须知需展示在移动端“已支付/待使用”订单详情，未填写内容则不展示使用须知",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "el-icon-question detail-editor-tooltip",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Tinymce", {
                    attrs: { height: 500, sourceType: "spu2" },
                    model: {
                      value: _vm.useNotice,
                      callback: function ($$v) {
                        _vm.useNotice = $$v
                      },
                      expression: "useNotice",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 3,
                  expression: "currentStep === 3",
                },
              ],
              staticClass: "step-content",
            },
            [
              _c("other", {
                ref: "otherParamsForm",
                model: {
                  value: _vm.parameterList,
                  callback: function ($$v) {
                    _vm.parameterList = $$v
                  },
                  expression: "parameterList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-btns" },
            [
              _c("el-button", { on: { click: _vm.handlePrev } }, [
                _vm._v("上一步"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleNext } },
                [_vm._v(_vm._s(_vm.currentStep === 3 ? "提交" : "下一步"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }